<template lang="pug">
thead.show--bigScreens
  tr
    th.color--greyCharcoal30.tableTop10-1c 編號
    th.tableTop10-2c.text--center.color--greyCharcoal30.text--left
      span 訊息
    th.color--greyCharcoal30.tableTop10-3c.text--center.tableTop-updatedAt(@click="sortByType('updatedAt')")
      span 更新時間
      i.tableTop10-arrowIcon.icon-arrow.icon-updatedAt
    th.color--greyCharcoal30.tableTop10-4c.text--center.show--bigScreens.tableTop-reporterCount(@click="sortByType('reporterCount')")
      span 舉報數
      i.tableTop10-arrowIcon.icon-arrow.icon-reporterCount
</template>
<script>
import { disableSort, initCurrentSortByQueryStr } from '@/plugins/tool.js';

export default {
  data() {
    return {
      currentSort: null
    };
  },
  mounted() {
    this.currentSort = initCurrentSortByQueryStr(this.$route.query.params);
  },
  methods: {
    sortByType(sortType) {
      var data = {
        type: sortType,
        direction: -1
      };
      if (this.currentSort === null) {
        this.currentSort = data;
      } else if (this.currentSort.type === data.type) {
        if (this.currentSort.direction === 0) {
          this.currentSort.direction = -1;
        } else if (this.currentSort.direction === -1) {
          this.currentSort.direction = 1;
        } else {
          this.currentSort.direction = 0;
        }
      } else {
        disableSort(this.currentSort.type);
        this.currentSort = data;
      }
      this.$emit('sortByType', this.currentSort);
    }
  }
};
</script>
